<div class="photos-section" #photosEl>
  <div
    class="photo-item"
    (click)="onSelect(i); $event.stopPropagation(); false"
    *ngFor="let photo of photos; let i = index"
  >
    <!-- TODO: move to sep component, highlight close on mouse move -->
    <div class="remove" (click)="onRemove(photo.id); $event.stopPropagation(); false">
      <svg viewBox="0 0 26 26">
        <use href="#cancel" />
      </svg>
    </div>
    <img [src]="photo.thumb_url | baseUrl" class="img-fluid" (load)="onLoad()" (error)="onError()" />
  </div>
</div>
